// removed by extract-text-webpack-plugin
module.exports = {"textContainer":"src-components-Invest-DisclaimerViews-___index__textContainer___3X7GZ","numbered":"src-components-Invest-DisclaimerViews-___index__numbered___2pzqt","lettered":"src-components-Invest-DisclaimerViews-___index__lettered___2EdPl","roman":"src-components-Invest-DisclaimerViews-___index__roman___egu7M","bulleted":"src-components-Invest-DisclaimerViews-___index__bulleted___1cD8Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Invest/DisclaimerViews/index.css
// module id = 273
// module chunks = 3